import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Member } from './App';
import Divider from '@mui/material/Divider';
import Chip from '@mui/material/Chip';
import ButtonGroup from '@mui/material/ButtonGroup';

const MAX_USERS = 3;

export default function ConfigGoalDialog(props: {
    open: boolean,
    currentMember?: Member,
    allMembers?: Member[],
    handleClose: (memberData?: {
      name: string,
      goal: string,
      photo: string,
    }) => void,
    chooseUser: (member: Member) => void,
}) {

  const [newMemberMode, setNewMemberMode] = React.useState(false);
  const [goal, setGoal] = React.useState('');
  const [name, setName] = React.useState('');
  const [photo, setPhoto] = React.useState('');

  const getMemberButtons = () => {
    if (!props.allMembers) return;

    const btns = props.allMembers?.map((member, idx) =>
      <Button onClick={() => props.chooseUser(member)} key={idx}>{member.name} - {member.goal}</Button>
    )
    return btns;
  }

  return (
    <div>
      <Dialog open={props.open} onClose={() => props.handleClose()}>
        <DialogTitle>User settings</DialogTitle>
        <DialogContent>

          { (props.allMembers && !newMemberMode) &&
            <>
            <DialogContentText>
              Select your user if you have already signed up
            </DialogContentText>

            <ButtonGroup style={{justifyContent: 'center', width: '100%'}}
              orientation="vertical"
              aria-label="vertical contained button group"
              variant="text"
            >
              {getMemberButtons()}
            </ButtonGroup>

            <Divider style={{marginTop: 25, width: '100%'}}>
              <Chip label="Or, join as a new user" onClick={() => setNewMemberMode(true)}/>
            </Divider>
            </>
          }
          { newMemberMode &&
          <>
          <DialogContentText>
            What's your name and goal to track? This will be shared with the group.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Your name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            fullWidth
            variant="standard"
          />
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Goal"
            type="text"
            value={goal}
            onChange={(e) => setGoal(e.target.value)}
            fullWidth
            variant="standard"
          />
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Profile photo URL"
            type="text"
            value={photo}
            onChange={(e) => setPhoto(e.target.value)}
            fullWidth
            variant="standard"
          />
          <Divider style={{marginTop: 25}}>
              <Chip label="I have already joined" onClick={() => setNewMemberMode(false)}/>
            </Divider>
          </>
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={() => props.handleClose()}>Cancel</Button>
          { newMemberMode &&
            <Button onClick={() => props.handleClose({name, goal, photo})}
            disabled={(props.allMembers && props.allMembers.length >= MAX_USERS)}>Join</Button>
          }
        </DialogActions>
      </Dialog>
    </div>
  );
}